import Api from "@/modules/axios";
import type { ResponseList } from "@/types/api";

export default class Communication {
  id?: number;
  titre!: string;
  texte!: string;
  couleur!: string;
  pages!: string[];
  date_modification?: string;
  date_creation?: string;

  constructor(data: Params<Communication>) {
    Object.assign(this, data);
  }

  static async fetchAll(): Promise<Communication[]> {
    try {
      const response: ResponseList<Communication> = await Api().get("/communication/");
      return response.data.results.map((item) => new Communication(item));
    } catch (error) {
      console.error("Erreur lors de la récupération des communications:", error);
      return [];
    }
  }

  static async delete(id: number): Promise<void> {
    try {
      await Api().delete(`/communication/${id}/`);
    } catch (error) {
      console.error("Erreur lors de la suppression de la communication:", error);
      throw error;
    }
  }

  static async updateOrCreate(data: Communication): Promise<Communication> {
    try {
      if (data.id) {
        // Update existing communication
        const response = await Api().patch(`/communication/${data.id}/`, data);
        return new Communication(response.data);
      }

      // Create new communication
      const response = await Api().post("/communication/", data);
      return new Communication(response.data);
    } catch (error) {
      console.error("Erreur lors de la création ou mise à jour de la communication:", error);
      throw error;
    }
  }
}
